import Icon from '@/components/Icon'

const ErrorMessage = () => {
  return (
    <section className="p-24 md:py-90 mx-auto max-w-7xl rounded-xlarge border border-display-300">
      <Icon name="error-circle" className="mx-auto mb-24" />

      <p className="pb-24 font-bold text-center text-display-600 ton-paragraph-18">
        Ocorreu um erro ao tentar carregar ou atualizar o formulário.
      </p>

      <p className="text-center text-display-600 ton-paragraph-16">
        Por favor,{' '}
        <span className="font-bold">atualize a página no seu navegador</span> e
        tente novamente.
      </p>
    </section>
  )
}

export default ErrorMessage
